module.exports = __webpack_public_path__ + "img/access.c7ae99ce.png";